import {
    AccountingReportComparison,
    AccountingReportComparisonDiff,
    AccountingReportCycle,
    AccountingReportRatioType,
} from "../constants";
import { JournalEntrySourceFilter } from "../schemas/domains/accounting/journalEntry";
import { ClassFilterType } from "./class";
import { AccountingLedgerBasis } from "./domains/accounting/ledger";
import { GoogleSheetsConnectionBase } from "./googleSheetsConnection";
import { ReportPeriodMode } from "./reports/period-mode";
import { AccountingReportType } from "./reports/report-type";
import { SchedulesReportLayout } from "./reports/schedules-report";
import { UserBase } from "./user";

export enum GoogleSheetsScheduleCadence {
    DISABLED = "disabled",
    DAILY = "daily",
    HOURLY = "hourly",
    EVERY_30_MINUTES = "every_30_minutes",
    EVERY_15_MINUTES = "every_15_minutes",
    EVERY_MONDAY = "every_monday",
    EVERY_FRIDAY = "every_friday",
    EVERY_OTHER_MONDAY = "every_other_monday",
    EVERY_OTHER_FRIDAY = "every_other_friday",
    FIRST_DAY_OF_MONTH = "first_day_of_month",
    FIFTEENTH_DAY_OF_MONTH = "fifteenth_day_of_month",
    LAST_DAY_OF_MONTH = "last_day_of_month",
    FIRST_DAY_OF_QUARTER = "first_day_of_quarter",
    LAST_DAY_OF_QUARTER = "last_day_of_quarter",
}

export enum GoogleSheetsScheduleStatus {
    ACTIVE = "active",
    PAUSED = "paused",
    DISCONNECTED = "disconnected",
}

export enum GoogleSheetsScheduleRunOutcome {
    SUCCESS = "success",
    PARTIAL = "partial",
    FAILED = "failed",
    SKIPPED = "skipped",
}

export interface GoogleSheetsScheduleReportImportParams {
    entityId: number;
    reportType: AccountingReportType;
    startDate: string;
    endDate: string;
    isEndDateToday?: boolean;
    basis: AccountingLedgerBasis;
    ledgerId?: string;
    classes?: string[];
    classFilterType?: ClassFilterType;
    comparisons?: AccountingReportComparison[];
    comparisonDiffs?: AccountingReportComparisonDiff[];
    counterpartiesIds?: string[];
    cycle?: AccountingReportCycle;
    periodMode?: ReportPeriodMode;
    ratioTypes?: AccountingReportRatioType[];
    accountCodes?: number[];
    journalEntrySources?: JournalEntrySourceFilter[];
    minAmount?: number;
    maxAmount?: number;
    layout?: SchedulesReportLayout;
}

export interface GoogleSheetsScheduleManagedReport {
    id: string;
    title: string;
    sheetName: string;
    importParams: GoogleSheetsScheduleReportImportParams;
}

export interface GoogleSheetsScheduleRunReportDetail {
    reportId: string;
    title: string;
    sheetName: string;
    didSucceed: boolean;
    errorCode?: string;
    errorMessage?: string;
    durationMs?: number;
}

export interface GoogleSheetsScheduleMetadata {
    spreadsheetUrl?: string;
    sourceDocumentId?: string;
    notes?: string;
    lastManualRefreshAt?: string;
    consecutiveFailures?: number;
}

export interface GoogleSheetsScheduleBase {
    id: string;
    userId: number;
    user?: UserBase;
    workspaceId: string;
    googleSheetsConnectionId: string | null;
    googleSheetsConnection?: GoogleSheetsConnectionBase | null;
    spreadsheetId: string;
    spreadsheetTitle: string | null;
    cadence: GoogleSheetsScheduleCadence;
    lastRunAt: Date | null;
    lastRunOutcome: GoogleSheetsScheduleRunOutcome | null;
    lastError: string | null;
    lastRunDetails: GoogleSheetsScheduleRunReportDetail[] | null;
    status: GoogleSheetsScheduleStatus;
    managedReports: GoogleSheetsScheduleManagedReport[];
    metadata: GoogleSheetsScheduleMetadata | null;
    createdAt: Date;
    updatedAt: Date;
}
